import React, { FC } from 'react';
import ExpFragmentPage from './ExpFragmentPage';
import { usePageTitle } from '@trip-ux/components';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { labelsSelector } from '../utils';
import { get } from 'lodash';

export const ConatctUsPage: FC<{ screen: string }> = ({ screen }) => {
  const { labels } = useSelector((store: ReduxStore) => ({
    labels: get(labelsSelector(store), 'page')
  }));

  usePageTitle(get(labels, 'title.contactUs'));

  return <ExpFragmentPage screen={screen} />;
};

ConatctUsPage.displayName = 'ContactUsPage';
export default ConatctUsPage;
